<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="payment_term.payment_term_id && payment_term.payment_term_id > 0"
                            @invoke-method="dbGetPaymentTerm(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="payment_term.payment_term_id && payment_term.payment_term_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('payment_terms.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in payment_term_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != payment_term.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('payment_terms.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_payment_term.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'payment_terms' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="payment_term.status" class="ribbon ribbon-top-right" :class="`ribbon-${payment_term.status_class}`">
                            <span class="ribbon-span">{{ payment_term.status }}</span>
                        </div>
                        <v-form ref="formPaymentTerm">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="payment_term_dialog"
                                    v-model="payment_term.term_days"
                                    :label="`${$t('lang.term_days')} *`"
                                    :counter="showCounter(payment_term.term_days, 'payment_terms.term_days')"
                                    :rules="ifValid('payment_terms.term_days')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="payment_term.description"
                                    :label="`${$t('lang.description')} *`"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('payment_terms.description')"
                                ></v-textarea>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'payment_terms' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="savePaymentTerms">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_payment_term"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_payment_term')"
                :message="$t('lang.delete_payment_term_confirm')"
                @onConfirm="deletePaymentTerms()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_payment_term_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeletePaymentTermDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            payment_term: {},
            file_name: "",
            dbGetPaymentTerm: _.debounce(this.getPaymentTerm, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchPaymentTerm", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.payment_term) {
                        this.payment_term = this.assignObj2(data.payment_term, this.rules_payment_terms);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=payment_term_status&sort_by=2",
                            method: "get",
                            stateProperty: "payment_term_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "payment_terms", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchPaymentTerm", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.payment_term) {
                        next((vm) => {
                            vm.payment_term = vm.assignObj2(data.payment_term, vm.rules_payment_terms);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=payment_term_status&sort_by=2",
                                method: "get",
                                stateProperty: "payment_term_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "payment_terms", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=payment_term_status&sort_by=2",
            method: "get",
            stateProperty: "payment_term_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_payment_terms: (state) => state.payment_terms.rules_payment_terms,
            payment_term_status_options: (state) => state.settings.payment_term_status_options,
            payment_terms: (state) => state.payment_terms.payment_terms,
            selectedPaymentTerm: (state) => state.payment_terms.selectedPaymentTerm,
        }),
    },
    methods: {
        ...mapActions(["fetchPaymentTerm", "savePaymentTerm", "deletePaymentTerm", "printPaymentTerm"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getPaymentTerm(pg_refresh = false) {
            this.startLoader();

            this.fetchPaymentTerm({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.payment_term) {
                    this.payment_term = this.assignObj2(data.payment_term, this.rules_payment_terms);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printPaymentTerm({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.payment_term) {
                    if (this.dev_mode) {
                        this.file_name = data.payment_term.file_name;
                    } else {
                        this.$refs.print.printReport(data.payment_term.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        savePaymentTerms() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formPaymentTerm")) {
                    let body = this.prepForm(this.payment_term, this.rules_payment_terms);

                    this.savePaymentTerm({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.payment_term) {
                            this.$router.push({ name: "payment_term", params: { id: data.payment_term.payment_term_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { payment_term_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.savePaymentTerms({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.payment_term) {
                    this.payment_term = this.assignObj2(data.payment_term, this.rules_payment_terms);
                }
            });
        },
        deletePaymentTerms() {
            this.deletePaymentTerm({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "payment_terms" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchPaymentTerm({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.payment_term) {
                        this.payment_term = this.assignObj2(data.payment_term, this.rules_payment_terms);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    created() {},
};
</script>
